import React, { Dispatch, SetStateAction } from 'react'

type AppContextType = {
  userRoles: Record<string, string>
  setUserRoles: Dispatch<SetStateAction<any>>
  userRoleSelected: any
  setUserRoleSelected: Dispatch<SetStateAction<any>>
  user: { email?: string }
  setUser: Dispatch<SetStateAction<{ email?: string }>>
  currentFarm: any
  programConfig: any
  program: any
  hideNavbar: boolean
  setHideNavbar: Dispatch<SetStateAction<boolean>>
  confirmationModalConfig: any
  setConfirmationModalConfig: Dispatch<SetStateAction<any>>
  loadingModalConfig: any
  setLoadingModalConfig: Dispatch<SetStateAction<any>>
  partialChanges: boolean
  setPartialChanges: Dispatch<SetStateAction<boolean>>
}

const AppContext = React.createContext<AppContextType>({
  userRoles: {},
  setUserRoles: () => null,
  userRoleSelected: {},
  setUserRoleSelected: () => null,
  user: {},
  setUser: () => null,
  currentFarm: {},
  programConfig: {},
  program: {},
  hideNavbar: false,
  setHideNavbar: () => null,
  confirmationModalConfig: {},
  setConfirmationModalConfig: () => null,
  loadingModalConfig: {},
  setLoadingModalConfig: () => null,
  partialChanges: false,
  setPartialChanges: () => null,
})
export const AppContextProvider = AppContext.Provider
export default AppContext
